import React, { useMemo } from "react";
import { View, StyleSheet, TouchableOpacity, ScrollView } from "react-native";
import { Text } from "react-native-paper";
import { useThemeSettings } from "../../../ThemeProvider";
import { Article } from "../../../shared/types/DataTypes";
import ThinkOLogo from "../../../components/ThinkoLogo";
import { MiniArticleCard } from "../../news-feed/components/MiniArticleCard";
import getGlobalStyles from "../../../globalStyles";
interface ChatBubbleAIProps {
    message: string;
    newsItems?: Article[];
    faqs?: any[];
    faqSelect?: (faq: any) => void;
}

const ChatBubbleAI: React.FC<ChatBubbleAIProps> = ({ message, newsItems, faqs, faqSelect }) => {
    const { theme } = useThemeSettings();
    const hasNews = newsItems && newsItems.length > 0;
    const gStyles = useMemo(() => getGlobalStyles(theme), [theme]);
    return (
        <View style={[{ marginBottom: 18, }]} key={ Date.now().toString() + "_ai_" + Math.random().toString(36).substring(7)} >
            <View style={styles.wrapper}>
                {/* AI Icon */}
                <ThinkOLogo size={24} />
                <View style={{ flex: 1, marginLeft: 12 }}>
                    <View style={[styles.bubble, { backgroundColor: theme?.colors?.chatBgAssistant }]}>
                        <Text style={[styles.text, { color: theme?.colors?.textPrimary }]}>
                            {message}
                        </Text>
                    </View>
                    {hasNews && (
                        <ScrollView horizontal style={{ marginTop: 16 }} showsHorizontalScrollIndicator={false}>
                            <View style={[gStyles.centerRow, { gap: 16 }]}>
                                {newsItems?.map((item) => (
                                    <MiniArticleCard key={item.id} article={item} />
                                ))}</View>
                        </ScrollView>
                    )}

                </View>

            </View>
            {
                faqs && faqs.length > 0 && (
                    <ScrollView horizontal style={{ paddingLeft: 16, marginTop: 16 }} showsHorizontalScrollIndicator={false}>
                        {faqs.map((faq: any, index: number) => (
                            <TouchableOpacity
                                onPress={() => faqSelect && faqSelect(faq.question)}
                                style={{ maxWidth: 150, backgroundColor: theme?.colors?.chatBgAssistant, borderRadius: 12, marginRight: 16, justifyContent: 'center', alignItems: 'center', padding: 8 }}
                                key={index}>
                                <Text style={[{ marginRight: 8 }]}>{faq.question}</Text>
                            </TouchableOpacity>))}
                    </ScrollView>
                )
            }
        </View>
    );
};

export default ChatBubbleAI;

const styles = StyleSheet.create({
    wrapper: {
        flexDirection: "row",
        alignItems: "flex-start",
        paddingHorizontal: 24,

    },

    bubble: {
        flex: 1,
        padding: 10,
        borderRadius: 12,
    },

    text: {
        color: "#000", // thinkO brand shade
        lineHeight: 18,
        fontSize: 12
    },

    icon: {
        marginRight: 12,
    },
    /** NEWS CARDS */
    newsSection: {
        marginTop: 12,
        gap: 12,
    },

    nextBtn: {
        width: 24,
        height: 24,
        borderRadius: 20,
        backgroundColor: "rgba(255,255,255,0.15)",
        justifyContent: "center",
        alignItems: "center",
    },
});